import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import { connect } from "react-redux";
import { DateRangePicker, DateRangeDelimiter } from "@material-ui/pickers";
import { Button, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import * as Var from "styles/variables";
import SingleSelect from "components/Select/SingleSelect";
import { setSaitamaDateRange, setSaitamaSeason } from "actions";
import {
  getSaitamaDefaultDateRange,
  getSaitamaLatestSelectableDate,
} from "reducers/pictree/pictreeSaitamaReducer";

const useStyles = makeStyles((theme) => ({
  calendarWrapper: { paddingLeft: 8, flexGrow: 1 },
  root: {
    backgroundColor: "#fafafa",
    zIndex: 1000,
    paddingTop: 16,
    paddingLeft: 8,
    marginTop: -12,
  },
  sectionCalendar: {
    display: "flex",
    marginRight: theme.spacing(1),
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  seasonWrapper: { marginRight: 16, marginTop: -16 },
  container: {
    display: "flex",
    width: 300,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    alignItems: "baseline",
  },
  delimiter: { paddingTop: theme.spacing(1) },
  dataBtn: {
    marginTop: theme.spacing(1.2),
    marginLeft: theme.spacing(1),
    height: theme.spacing(4),
    color: Var.btnLabelColor,
  },
}));

const CalendarRangePicTreeSaitama = ({
  selectedSeason,
  seasonData,
  dateRange,
  setSaitamaDateRange,
  setSaitamaSeason,
}) => {
  const classes = useStyles();
  const season = selectedSeason[0] || seasonData[0];
  const [draftRange, setDraftRange] = useState(dateRange);
  const maxSelectableDate = getSaitamaLatestSelectableDate(season);
  const isInvalidRange = draftRange[0] && draftRange[1]
    ? moment.tz(draftRange[0], "YYYY-MM-DD", "Asia/Tokyo").isAfter(
      moment.tz(draftRange[1], "YYYY-MM-DD", "Asia/Tokyo"),
      "day"
    )
    : false;

  useEffect(() => {
    setDraftRange(dateRange);
  }, [dateRange]);

  const handleSeasonChange = (event) => {
    const nextSeason = seasonData.filter((item) => item.seasonId === event.target.value);
    if (nextSeason.length > 0) {
      setSaitamaSeason(nextSeason);
      setDraftRange(getSaitamaDefaultDateRange(nextSeason[0]));
    }
  };

  const handleRangeChange = (newValue) => {
    if (!newValue) return;
    setDraftRange([
      newValue[0] ? moment(newValue[0]).format("YYYY-MM-DD") : null,
      newValue[1] ? moment(newValue[1]).format("YYYY-MM-DD") : null,
    ]);
  };

  const applyRange = () => {
    if (!isInvalidRange && draftRange[0] && draftRange[1]) setSaitamaDateRange(draftRange);
  };

  return (
    <div className={classes.calendarWrapper}>
      <div className={classes.root}>
        <div className={classes.sectionCalendar}>
          <div className={classes.seasonWrapper}>
            <SingleSelect
              selected={{ name: season.displayName, value: season.seasonId }}
              options={seasonData.map((item) => ({ name: item.displayName, value: item.seasonId }))}
              handleChange={handleSeasonChange}
            />
          </div>
          <DateRangePicker
            startText="Start"
            endText="End"
            disableHighlightToday={true}
            showToolbar={false}
            allowSameDateSelection={true}
            calendars={2}
            minDate={season.seasonStart}
            maxDate={maxSelectableDate}
            value={draftRange}
            onChange={handleRangeChange}
            renderInput={(startProps, endProps) => (
              <div className={classes.container}>
                <TextField {...startProps} error={isInvalidRange} size="small" helperText="" />
                <DateRangeDelimiter><span className={classes.delimiter}>~</span></DateRangeDelimiter>
                <TextField {...endProps} error={isInvalidRange} size="small" helperText="" />
              </div>
            )}
          />
          <Button className={classes.dataBtn} variant="contained" color="primary" onClick={applyRange}>
            GO
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  selectedSeason: state.pictreeSaitama.selectedSeason,
  seasonData: state.pictreeSaitama.seasonData,
  dateRange: state.pictreeSaitama.dateRange,
});

const mapDispatchToProps = (dispatch) => ({
  setSaitamaDateRange: (value) => dispatch(setSaitamaDateRange(value)),
  setSaitamaSeason: (value) => dispatch(setSaitamaSeason(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarRangePicTreeSaitama);
